import { createSlice } from "@reduxjs/toolkit"

const adPostAttemptsSlice = createSlice({
   name: "adPostAttempts",
   initialState: {
      adPostAttempts: null,
      createAdPostAttemptsLoading: false
   },
   reducers: {
      createAdPostAttemptsLoading: (state) => {
         state.createAdPostAttemptsLoading = true
      },
      createAdPostAttemptsSuccess: (state, action) => {
         state.adPostAttempts = action.payload
         state.createAdPostAttemptsLoading = false
      },
      createAdPostAttemptsFailure: (state) => {
         state.createAdPostAttemptsLoading = false
      }
   }
})

export const {
   createAdPostAttemptsLoading,
   createAdPostAttemptsSuccess,
   createAdPostAttemptsFailure
} = adPostAttemptsSlice.actions

export default adPostAttemptsSlice.reducer 